import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import { Link } from "gatsby";
import '../home.css'

const BlogCard = ({ data }) => {
  const {
    card_bg_color,
    card_image,
    heading,
    card_button: { label, label_color, href, bg_color } = {},
  } = data || {};

  return (
    <div className="rounded-[1vw] w-[75vw] m-auto xl:w-full overflow-hidden flex flex-col justify-between">
      {/* Blog Image */}
      {card_image?.url && (
        <div className="xl:w-full h-[20vh] xl:h-[32vh]">
          <ImageProvider
            Image={card_image}
            alt={heading}
            tailwindStyle="w-full h-full object-contain rounded-t-[2vh] xl:rounded-t-[1vw]"
          />
        </div>
      )}

      {/* Content */}
      <div
        className="min-h-[24vh] xl:min-h-[28vh] p-[4vw] xl:p-[2vw] flex flex-col rounded-b-[2vh] xl:rounded-b-[1vw] justify-between flex-1 blog-card-text"
        style={{ backgroundColor: card_bg_color }}
      >
        <h3 className="text-[2.2vh] text-center xl:text-[1.2vw] font-semibold text-[#002C61] mb-[2vh]">
          {heading}
        </h3>

        {label && (
          <div className="flex items-end">
            <Link
              to={href || "#"}
              className="min-w-[45%] lg:min-w-[40%] m-auto inline-block text-center py-[0.5vh] xl:py-[0.2vh] px-[4vh] xl:px-[2vh] rounded-[1vh] xl:rounded-[1.2vh] text-[2.2vh] xl:text-[2.8vh] font-normal"
              style={{
                backgroundColor: bg_color || "#fff",
                color: label_color || "#000",
              }}
            >
              {label}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogCard;
